export default __webpack_public_path__ + "7d87c4eefaa9a6bee37f141243cc6f75.svg";